import {Select, SelectProps} from "@mantine/core";
import {Prefectures} from "./Prefectures";

interface Props extends Omit<SelectProps, "data"> {

}

function JapanPrefecture(props: Props) {

    function serializePrefectures() {
        return Prefectures.map((pref) => ({value: pref.prefecture_romaji, label: `${pref.prefecture_romaji} (${pref.prefecture_kanji})`}))
    }

    return (
        <Select {...props} data={serializePrefectures()}/>
    )

}

export default JapanPrefecture;